
export default function Item({ id, title, kids, level = 1 }) {

    return (<div style={{ "paddingLeft": level * 10 + "px", "border": "0px solid red" }}>
        <b>{title}</b>
        {kids.map(item => (<Item key={item.id} id={item.id} title={item.title} kids={item.kids} level={level + 1} />))}

    </div>
    )
}